$('select[name="cboDegreeProgYear"]').on('change', function () {
    window.location = base_url + 'important-documents/report/download?degreeprogyr=' + $(this).val() + '&docid=' + $('select[name="cboImportantdocs"]').val();
});

$('select[name="cboImportantdocs"]').on('change', function () {
    window.location = base_url + 'important-documents/report/download?degreeprogyr=' + $('select[name="cboDegreeProgYear"]').val() + '&docid=' + $(this).val();
});

$('#select_all').on('change', function (event) { // Select all checkboxes
    $(':checkbox').prop('checked', $(this).prop('checked'));
});
